import { connect } from "react-redux";
import Calendar from "../../Calendar/Calendar";
import { getEventDates } from "../../../utils";
import Reveal from "../Reveal";
import Section from "./Section";

/**
 * The wedding month with the celebration days marked, right after the first
 * page, in the venue section's arch-shaped double border (without its image).
 */
const CalendarSection = ({ events }) => {
  const eventDates = getEventDates(events);
  if (!eventDates.length) return null;

  return (
    <Section className="rm-calendar" label="Wedding calendar" kicker="Mark Your Calendar" title="Save the Date">
      <Reveal effect="fade" className="rm-calendar__arch" delay={0.1}>
        <div className="rm-calendar__card">
          <Calendar eventDates={eventDates} />
        </div>
      </Reveal>
    </Section>
  );
};

const mapStateToProps = (state) => ({
  events: state.inviteDetails.invite?.events,
});

export default connect(mapStateToProps)(CalendarSection);
